import { useMemo as i } from "react";
const t = function(e) {
  return i(() => e.size ?? "medium", [e]);
};
export {
  t as useSize
};
//# sourceMappingURL=useSize.mjs.map
